import React from "react";
import styles from "./PdfViewer.module.css";
import { Row } from "react-bootstrap";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin, ToolbarSlot } from "@react-pdf-viewer/toolbar";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { PdfViewerProps } from "./PdfViewer.utils";

/**
 * PdfViewer Component
 */
const PdfViewer: React.FC<PdfViewerProps> = ({ preview }) => {
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  const getFilePluginInstance = getFilePlugin();
  const { DownloadButton } = getFilePluginInstance;
  return (
    <div className={styles.pdfViewerWrapper}>
      <Row className={styles.pdfViewerToolbar}>
        <Toolbar>
          {(slots: ToolbarSlot) => {
            const { ZoomIn, ZoomOut } = slots;

            return (
              <div className={styles.toolbar}>
                <div className={styles.flexBox}>
                  <ZoomOut />
                  <ZoomIn />
                </div>
                <div className={styles.flexBox}>
                  <strong>{preview?.name}</strong>
                </div>
                <div className={styles.flexBox}>
                  <DownloadButton />
                </div>
              </div>
            );
          }}
        </Toolbar>
      </Row>
      <Row className={styles.pdfViewerBody}>
        {preview?.url ? (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              key={preview?.url}
              fileUrl={preview.url}
              plugins={[toolbarPluginInstance, getFilePluginInstance]}
              defaultScale={1.0}
            />
          </Worker>
        ) : (
          <span className={styles.previewFileMessage}>
            Please select a file to preview.
          </span>
        )}
      </Row>
    </div>
  );
};

export default PdfViewer;
